import apiClient from "../helper/apiClient";
import { validateUserKey } from "./validateUserKey";

export default async function getCallSessionID(requestObject) {
  validateUserKey(requestObject.userKey);
  try {
    const { data } = await apiClient.get("api/getCallSessionID", {
      params: requestObject,
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
